import React from 'react'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import { BrowserBar } from './browser-bar'

export const browserBarWidth: number = 50

export interface Browser {
  readonly agentName: string
  readonly agentVersion: string
}

interface Result {
  readonly applicationLiveArchitecture: {
    readonly browsers: Browser[]
  }
}

interface Vars {
  readonly applicationID: string
  readonly organizationID: string
}

interface WrappedBrowserBarProps {
  readonly applicationID: string
  readonly organizationID: string
}

export function WrappedBrowserBar({
  applicationID,
  organizationID
}: WrappedBrowserBarProps) {
  return (
    /* TODO probably it'd be a good idea that the endpoint supports expand for calculating only the required fields */
    <Query<Result, Vars>
      pollInterval={10000}
      query={gql`
        query ApplicationLiveArchitectureQuery(
          $organizationID: ID!
          $applicationID: ID!
        ) {
          applicationLiveArchitecture(
            organizationID: $organizationID
            applicationID: $applicationID
          ) {
            browsers {
              agentName
              agentVersion
            }
          }
        }
      `}
      variables={{
        applicationID,
        organizationID
      }}
    >
      {({ loading, data }) => {
        if (loading || !data) {
          return <div />
        }

        const {
          applicationLiveArchitecture: { browsers = [] }
        } = data

        if (browsers.length === 0) {
          return <div />
        }

        return <BrowserBar browsers={browsers} />
      }}
    </Query>
  )
}
